import { graphql, useStaticQuery } from "gatsby"

// The podcast's newest episodes, read from its public feed at build time
// (see gatsby/podcastEpisodes.js). Empty when the feed could not be read.
export const usePodcastEpisodes = () => {
  const { allPodcastEpisode } = useStaticQuery(graphql`
    query GetPodcastEpisodes {
      allPodcastEpisode(sort: { fields: publishedOn, order: DESC }, limit: 5) {
        nodes {
          id
          applePodcastLink
          slug
          durationMinutes
          episode
          publishedOn
          releaseDate: publishedOn(formatString: "MMM D, YYYY")
          season
          spotifyLink
          summary
          title
          youtubeLink
        }
      }
    }
  `)
  return allPodcastEpisode.nodes.map(episode => ({
    ...episode,
    summary: { summary: episode.summary },
  }))
}
